module.exports = __webpack_public_path__ + "static/img/7.b9ff05d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/7.png
// module id = mn0o
// module chunks = 1 3